import { render, staticRenderFns } from "./DynamicSection.vue?vue&type=template&id=52b33374&"
import script from "./DynamicSection.vue?vue&type=script&lang=js&"
export * from "./DynamicSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports